import { render, staticRenderFns } from "./CacMandateSwitches.vue?vue&type=template&id=57d7a990"
import script from "./CacMandateSwitches.vue?vue&type=script&lang=js"
export * from "./CacMandateSwitches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports